// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Button, Paper, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from '@mui/material'
import React, { Component } from 'react'
import { Mutation } from 'react-apollo'
import { removeTypename } from '../../../common/utils'
import { i18n } from '../../index'
import { upsertScoreCardThresholds } from './queries'
import css from './scoreCardThresholds.css'

class ScoreCardThreshold extends Component<any, any> {
  state = {
    editing: false,
    upstream: removeTypename(this.props.data),
    editable: removeTypename(this.props.data),
  }
  onRowChange = (scoreKey: string, highOrLow: 'high' | 'low') => (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = +e.target.value
    this.setState(({ ...prevState }: any) => {
      prevState.editable[scoreKey][highOrLow] = value
      return prevState
    })
  }
  onSectionThresholdsChange = (key: string, highOrLow: 'high' | 'low') => (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = +e.target.value
    this.setState(({ ...prevState }: any) => {
      prevState.editable.sectionTotals[key][highOrLow] = value
      return prevState
    })
  }
  handleCancel = () => {
    return this.setState({
      editing: false,
    })
  }
  submit = (mutate: any) => async () => {
    if (!this.state.editing) {
      return this.setState({
        editing: true,
      })
    }

    const newData = { ...this.state.editable, stationId: this.props.stationId }
    const payload = {
      variables: {
        data: newData,
      },
    }
    await mutate(payload)
    return this.setState({
      editing: false,
      upstream: this.state.editable,
    })
  }

  render() {
    const { editable, upstream, editing } = this.state
    const sectionThresholds = editing ? editable.sectionTotals : upstream.sectionTotals
    const otherThresholds = editing ? editable.otherThresholds : upstream.otherThresholds
    return (
      <Mutation mutation={upsertScoreCardThresholds} fetchPolicy='network-only'>
        {(mutate, { loading }) => (
          <div>
            <Paper>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <span>{i18n.t('admin.scoreCardThresholds.metricHeading')}</span>
                    </TableCell>
                    <TableCell>
                      <span>{i18n.t('admin.scoreCardThresholds.highHeading')}</span>
                    </TableCell>
                    <TableCell>
                      <span>{i18n.t('admin.scoreCardThresholds.lowHeading')}</span>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Object.entries(editing ? editable : upstream)
                    .filter(([k]) => !['sectionTotals', 'otherThresholds'].includes(k))
                    .map(([key, values]: [any, any]) => {
                      return (
                        <TableRow key={key}>
                          <TableCell className={css.firstCell}>
                            <span>{i18n.t(`admin.scoreCardThresholds.metric.${key}`)}</span>
                          </TableCell>
                          <TableCell>
                            {editing ? (
                              <TextField
                                type='number'
                                name={`${key}-high`}
                                value={values.high || 0}
                                onChange={this.onRowChange(key, 'high')}
                              />
                            ) : (
                              values.high
                            )}
                          </TableCell>
                          <TableCell>
                            {editing ? (
                              <TextField
                                type='number'
                                name={`${key}-low`}
                                value={values.low || 0}
                                onChange={this.onRowChange(key, 'low')}
                              />
                            ) : (
                              values.low
                            )}
                          </TableCell>
                        </TableRow>
                      )
                    })}
                </TableBody>
              </Table>

              <Typography variant={'h6'} className={css.sectionsHeading}>
                {i18n.t('admin.scoreCardThresholds.sectionsHeading')}
              </Typography>

              <Table>
                <TableBody>
                  {Object.keys(sectionThresholds).map((key) => {
                    const values = sectionThresholds[key]
                    return (
                      <TableRow key={key}>
                        <TableCell className={css.firstCell}>
                          <span>{i18n.t(`admin.scoreCardThresholds.section.${key}`)}</span>
                        </TableCell>
                        <TableCell>
                          {editing ? (
                            <TextField
                              type='number'
                              name={`${key}-high`}
                              value={values.high || 0}
                              onChange={this.onSectionThresholdsChange(key, 'high')}
                            />
                          ) : (
                            values.high
                          )}
                        </TableCell>
                        <TableCell>
                          {editing ? (
                            <TextField
                              type='number'
                              name={`${key}-low`}
                              value={values.low || 0}
                              onChange={this.onSectionThresholdsChange(key, 'low')}
                            />
                          ) : (
                            values.low
                          )}
                        </TableCell>
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            </Paper>
            <div className={css.bottom}>
              {editing && (
                <Button
                  style={{
                    marginRight: `10px`,
                  }}
                  variant='contained'
                  color='secondary'
                  onClick={this.handleCancel}
                >
                  {i18n.t('buttons.cancel')}
                </Button>
              )}
              <Button
                variant='contained'
                disabled={loading}
                color='primary'
                type='submit'
                onClick={this.submit(mutate)}
              >
                {loading ? 'Lataa...' : editing ? i18n.t('buttons.save') : i18n.t('buttons.edit')}
              </Button>
            </div>
          </div>
        )}
      </Mutation>
    )
  }
}

export default ScoreCardThreshold
